import { useState, useEffect } from 'react';
import './Games.scss';
import { url, token } from '../../utils/Config/config';
import Banner from '../../components/Banner/Banner';
import Card from '../../components/Card/Card';
import Loader from "react-loader-spinner";
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import Error from '../Error/Error';


const Games = () => {
    const [games, setGames] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    let number = page;

    useEffect(() => {
        const getGames = async () => {
            setLoading(true);
            try {
               let response = await axios.get(`${url}/games?key=${token}&page=${page}`);
               setGames(response.data.results);
               setLoading(false);
            } catch(e) {
                setError(true);
                console.log(e.message);
            }
        }
        getGames();
    }, [ page ]);

    return (
        error ? <Error /> :
        <div className="Games">
            <Banner 
                bannerTitle="All Games"
            />
            <div className="container">
                <div className="row mt-5">
                    <div className="col">
                        <nav aria-label="Page navigation example">
                            <ul className="pagination">
                                <li className="page-item">
                                    <button className="page-link" onClick={() => setPage(number-1)}>Previous</button>
                                </li>
                                <li className="page-item">
                                    <p className="page-link">{page}</p>
                                </li>
                                <li className="page-item">
                                    <button className="page-link" onClick={() => setPage(number++)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="row mb-5">
                {loading ? 
                    <Loader
                        className="loader"
                        type="ThreeDots"
                        color="#dc3545"
                        height={60}
                        width={60}
                    />
                  :
                    games.map((game, index) => {
                    return(
                        <div className="col-md-4 col-lg-3 my-3" key={index}>
                            <NavLink className="card-link" to={`/games/${game.slug}`}>
                                <Card 
                                    img={game.background_image}
                                    title={game.name}
                                    rating={game.rating}
                                    platforms={game?.parent_platforms?.map((platform, index) => {
                                        return(
                                            <span className="badge bg-danger me-1" key={index}>{platform.platform.name}</span>
                                        );
                                    })}
                                />
                            </NavLink>
                        </div>
                    );
                })}
                </div>
            </div>
        </div>
    );
};

export default Games;
